module.exports = __webpack_public_path__ + "img/banner-28.93d79c2b.jpg";